/* eslint-disable max-len */
import { ICONS } from "../components/Icons";
import routes, { smeBaseName } from "../routes";
import callbackRegular from "./../assets/gif/callback_regular.gif";

export const OtpChannel = {
  Sms: "sms",
  Email: "email"
};

export const authorityType = [
  { value: "AuthorityType1", label: "AuthorityType1" },
  { value: "AuthorityType2", label: "AuthorityType2" }
];

export const formStepper = [
  {
    step: 1,
    title: "Your info",
    path: routes.applicantInfo,
    relatedPath: [routes.verifyEmailOtp, routes.verifyMobileOtp]
  },
  { step: 2, title: "Company info", path: routes.companyInfo },
  {
    step: 3,
    title: "ID verification",
    path: routes.stakeholdersInfo,
    relatedPath: [routes.stakeholdersPreview, routes.StakeholderTermsAndConditions]
  },
  {
    step: 4,
    title: "Business details",
    path: routes.additionalInfoComponent,
    relatedPath: [routes.additionalCompanyInformation, routes.additionalStakeholderInformation]
  },
  { step: 5, title: "Account preferences", path: routes.accountServices },
  { step: 6, title: "Review and submit", path: routes.reviewAndSubmit }
];

export const additionInfoStepper = [
  {
    step: 1,
    title: "Additional information",
    path: routes.additionalInformation,
    relatedPath: [routes.comeBackLoginVerification]
  }
];

export const agentFormStepper = [
  { step: 1, title: "Search Applications", path: routes.searchProspect },
  { step: 2, title: "Send Invite", path: routes.inviteCustomer }
];

export const searchProspectStepper = [
  {
    step: 1,
    title: "Search Applications",
    path: routes.searchProspect,
    titleInfo: ""
  }
];

export const digitRegExp = new RegExp("^[0-9]$");

export const CONVENTIONAL = "conventional";
export const ISLAMIC = "islamic";

export const accountNames = {
  starter: "RAKStarter",
  currentAccount: "Current Account",
  elite: "RAKelite"
};

export const accountTitles = {
  starter: "RAKstarter",
  currentAccount: "Current Account",
  elite: "Business Elite"
};

export const AccountDetails = {
  [accountNames.starter]: {
    subProductCode: {
      [CONVENTIONAL]: "ACNS3",
      [ISLAMIC]: "GCNS4"
    },
    isElite: false
  },
  [accountNames.currentAccount]: {
    subProductCode: {
      [CONVENTIONAL]: "ACNS6",
      [ISLAMIC]: "GCNS2"
    },
    isElite: false
  },
  [accountNames.elite]: {
    subProductCode: {
      [CONVENTIONAL]: "ACNS6-DBO",
      [ISLAMIC]: "GCAP1"
    },
    isElite: true
  }
};

export const UAE_CODE = "971";
export const UAE = "AE";
export const UAE_CURRENCY = "AED";
export const MAX_EMAIL_LENGTH = 50;

export const REQUEST_LOADING = "loading";
export const REQUEST_SUCCESS = "success";

export const normalScrollHeight = 740;

const RO_EDITING = "12013";
const CIF_EXIST = "12012";
const INVALID_PROSPECT_ID = "12002";
const OCCURRED_WHILE_CREATING_CIF = "EXP101";
const NO_RESULT_FOUND = "12009";
const CLIENT_SIDE_VALIDATION_ERROR = "FATAL0001";
const HAPPENED_WHILE_PERFORMING_AUDIT_WHILE_UPDATE_PROSPECT = "10004";
const NO_RECORDS_FETCHED_WHILE_RETRIEVING_CORD = "I001F/12000";
const ERROR_OCCURRED_WHILE_PERFORMING_VALIDATION_CHECKS = "EXP101";
const COMMON_SERVER_ERROR = "INV0001";
const OTP_MAX_ATTEMPTS = "12060";

const IDNUMBER_UNAVAILABLE = "001";
const INVALID_IDNUMBER = "002";
const EXPIRED_EID = "003";
const EXPIRED_PASSPORT = "004";
const PASSPORT_NUMBER_UNAVAILABLE = "018";
const PASSPORT_ISSUING_COUNTRY_UNAVAILABLE = "019";
const PASSPORT_DOCTYPE_UNAVAILABLE = "020";
const CHECKSUM_FAILED = "025";
const EID_MISMATCH_CODE_OCR = "200102";

const RO_STOP =
  "We noticed that your application is incomplete. Not to worry, our team is already working on it.";
const EXIST = "We already have your application. Not to worry, our team is already working on it.";
const INVALID_ID = "Invalid Prospect ID";
const COMMON_ERROR =
  "We already have your application. Not to worry, our team is already working on it.";
export const INVALID_DOCUMENT = "Please scan/upload a valid file.";

export const EID_EXPIRY =
  "Your Emirates ID has expired/ is expiring in next 10 days. Please scan/upload a valid/renewed Emirates ID";
export const AGE_RESTRICTION =
  "Please ensure that the uploaded EID or passport corresponds to an age above 18 years. Failing to meet this criteria may result in the decline of your application.";
export const PASSPORT_EXPIRY =
  "Your passport has expired/ is expiring in next 10 days. Please upload a valid/ renewed passport.";
export const DOC_MISMATCH =
  "Your Emirates ID and Passport do not match. Please upload a valid Passport or Emirates ID.";
export const IDENTITY_VERIFICATION_FAIL = "Verification failed";
export const CHECKSUM_FAILED_MESSAGE =
  "Sorry, we are unable to process the document. Please try again with a clearer copy or use the scan option";

export const EID_DOC_MISMATCH = "Please upload a valid Emirates ID.";

export const PROSPECT_STATUSES = {
  ASSESSING: "Assessing",
  DOCUMENTS_NEEDED: "Documents needed",
  NEED_ADDITIONAL_DOCUMENTS: "Need Additional Information/Documents",
  ADDITIONAL_INFO_REQUIRED: "Additional Info Required"
};

export const ERROR_MESSAGES = {
  [RO_EDITING]: RO_STOP,
  [CIF_EXIST]: EXIST,
  [INVALID_PROSPECT_ID]: INVALID_ID,
  [OCCURRED_WHILE_CREATING_CIF]: COMMON_ERROR,
  [CLIENT_SIDE_VALIDATION_ERROR]: COMMON_ERROR,
  [HAPPENED_WHILE_PERFORMING_AUDIT_WHILE_UPDATE_PROSPECT]: COMMON_ERROR,
  [NO_RECORDS_FETCHED_WHILE_RETRIEVING_CORD]: COMMON_ERROR,
  [ERROR_OCCURRED_WHILE_PERFORMING_VALIDATION_CHECKS]: COMMON_ERROR,
  [COMMON_SERVER_ERROR]: COMMON_ERROR,
  [IDNUMBER_UNAVAILABLE]: INVALID_DOCUMENT,
  [INVALID_IDNUMBER]: INVALID_DOCUMENT,
  [PASSPORT_NUMBER_UNAVAILABLE]: INVALID_DOCUMENT,
  [PASSPORT_ISSUING_COUNTRY_UNAVAILABLE]: INVALID_DOCUMENT,
  [PASSPORT_DOCTYPE_UNAVAILABLE]: INVALID_DOCUMENT,
  [EXPIRED_EID]: EID_EXPIRY,
  [EXPIRED_PASSPORT]: PASSPORT_EXPIRY,
  [CHECKSUM_FAILED]: CHECKSUM_FAILED_MESSAGE,
  [EID_MISMATCH_CODE_OCR]: EID_DOC_MISMATCH
};

export const APP_STOP_SCREEN_RESULT = "stop";
export const HANDLED_ERROR_CODES = [
  RO_EDITING,
  CIF_EXIST,
  INVALID_PROSPECT_ID,
  OCCURRED_WHILE_CREATING_CIF,
  CLIENT_SIDE_VALIDATION_ERROR,
  HAPPENED_WHILE_PERFORMING_AUDIT_WHILE_UPDATE_PROSPECT,
  NO_RECORDS_FETCHED_WHILE_RETRIEVING_CORD,
  ERROR_OCCURRED_WHILE_PERFORMING_VALIDATION_CHECKS,
  COMMON_SERVER_ERROR,
  OTP_MAX_ATTEMPTS
];

export const IGNORE_ERROR_CODES = [NO_RESULT_FOUND, RO_EDITING];

export const COMPANY_DOCUMENTS = "companyDocuments";
export const STAKEHOLDER_DOCUMENTS = "stakeholdersDocuments";
export const OTHER_DOCUMENTS = "otherDocuments";

// ro-assist-brd2-1
export const COMPANY_BANK_STATEMENTS = "companyBankStatements";
export const COMPANY_ADDRESS_PROOF = "companyAddressProof";
export const COMPANY_INVOICES = "companyInvoices";
export const PERSONAL_BANK_STATEMENTS = "personalBankStatements";
export const PERSONAL_BACKGROUND = "personalBackground";

export const COMPANY_BANK_STATEMENTS_DOCTYPE = "Bank_Statements";
export const COMPANY_ADDRESS_PROOF_DOCTYPE = "Company_Address_Proof";
export const COMPANY_INVOICES_DOCTYPE = "Invoices_Contracts_Shipment_MOU_Custom";
export const PERSONAL_BANK_STATEMENTS_DOCTYPE = "Personal_Bank_Statements";
export const PERSONAL_BACKGROUND_DOCTYPE = "CV_Personal_Background";

export const companyMultiDocs = [COMPANY_BANK_STATEMENTS, COMPANY_ADDRESS_PROOF, COMPANY_INVOICES];
export const stakeholderMultiDocs = [PERSONAL_BANK_STATEMENTS, PERSONAL_BACKGROUND];
export const CREAT_PROSPECT_KEYS = [
  "applicantInfo",
  "generalInfo",
  "applicationInfo",
  "accountInfo",
  "organizationInfo",
  "orgKYCDetails",
  "companyAdditionalInfo",
  "signatoryInfo",
  "channelServicesInfo",
  "documents",
  "prospectStatusInfo",
  "kycAnnexure",
  "notifyApplicationRequest",
  "additionalDataForBPM",
  "accordionsStatus",
  "freeFieldsInfo",
  "partnersDetailInfo",
  "dulLicenseInfo",
  "sid"
];

/* Action Types */
export const SAVE = "save";
export const SUBMIT = "submit";

/* Save Types */
export const AUTO = "auto";
export const CONTINUE = "continue";
export const NEXT = "next";
export const BAU_PROSPECT_VERSION = "v1";
export const SIGNING_TRANSACTIONS_TYPE = {
  ALL: "101",
  ANY: "100",
  OTHER: "000",
  SINGLY: "102"
};
//ro-assist-brd1-3
const blank = "_blank";

export const EFR_CHECK = "EFR Check";
export const smeSouqLink = "https://rakbank.ae/wps/portal/business-banking/smesouk";
export const EFR_CHECK_ERROR = `Dear Customer, we were unable to complete your facial recognition process successfully. Not to worry! You may still proceed with our alternative application platform by clicking this secure link.<a href="${process.env.REACT_APP_BAU_URL}" target="${blank}"> ${process.env.REACT_APP_BAU_URL}....</a>`;

export const INELIGIBLE_COUNTRY_CHECK = "Ineligible country check";
export const INELIGIBLE_COUNTRY_CHECK_TAX_DECLARATION = "Tax Declaration Ineligible Country Check";
export const INELIGIBLE_COUNTRY_CHECK_COUNTRY_OF_BIRTH =
  "Ineligible Country Check for Country of Birth";
export const TL_STAKEHOLDER_COUNT_CHECK = "TL Stakeholder Count Check";

export const TL_STAKEHOLDER_COUNT_CHECK_ERROR =
  "Your business profile requires a different application$We'll redirect you to the right form. This won’t take long.";

const backToHomeButtons = [
  { external: false, link: routes.quickapplyLanding, label: "Back to home" }
];

const goToApplicationButtons = [
  { external: false, link: routes.comeBackLogin, label: "Go to Application" }
];

const checkStatusButtons = [
  { external: false, link: routes.comeBackLogin, label: "Yes, check status" },
  { external: false, link: routes.quickapplyLanding, label: "No, thanks" }
];

export const applicationError = [
  { screeningNotes: "DECLINE", link: true, buttons: backToHomeButtons },
  { screeningNotes: "INELIGIBLE", link: true, buttons: backToHomeButtons }
];

export const applicationDedupeError = [
  { screeningNotes: "DECLINE", link: true, buttons: backToHomeButtons },
  { screeningNotes: "INELIGIBLE", link: true, buttons: backToHomeButtons },
  { screeningNotes: "PENDING", link: true, buttons: goToApplicationButtons },
  { screeningNotes: "EFR_PENDING", link: true, buttons: goToApplicationButtons },
  { screeningNotes: "ADDITIONAL_INFORMATION", link: true, buttons: goToApplicationButtons },
  { screeningNotes: "APPROVED", link: true, buttons: checkStatusButtons },
  { screeningNotes: "INITIATE_ACCOUNT", link: true, buttons: checkStatusButtons },
  { screeningNotes: "INFORMATION_CORRECTION", link: true, buttons: checkStatusButtons },
  { screeningNotes: "COURIER_DISPATCH", link: true, buttons: checkStatusButtons },
  { screeningNotes: "ACCOUNT_ACTIVATED", link: true, buttons: checkStatusButtons },
  { screeningNotes: "CLOSED", link: true, buttons: checkStatusButtons },
  { screeningNotes: "PERSONA_CHANGE", link: true, buttons: checkStatusButtons },
  { screeningNotes: "WITH_RO", link: true, buttons: checkStatusButtons },
  { screeningNotes: "WITH_OPERATOR", link: true, buttons: checkStatusButtons },
  { screeningNotes: "SUCCESS", link: true, buttons: checkStatusButtons }
];
export const applicationdedupe = [
  {
    screeningNotes: "DECLINE",
    link: true,
    buttons: [
      {
        external: false,
        link: routes.quickapplyLanding,
        label: "Go to home page"
      }
    ]
  },
  {
    screeningNotes: "INELIGIBLE",
    link: true,
    buttons: [
      {
        external: false,
        link: routes.quickapplyLanding,
        label: "Go to home page"
      }
    ]
  },
  {
    screeningNotes: "PENDING",
    link: true,
    buttons: [
      {
        external: false,
        link: routes.comeBackLogin,
        label: "Continue"
      }
    ]
  },
  {
    screeningNotes: "SUCCESS",
    link: true,
    buttons: [
      {
        external: true,
        link: smeSouqLink,
        label: "No, thanks"
      },
      {
        external: false,
        link: routes.comeBackLogin,
        label: "Yes"
      }
    ]
  },
  {
    screeningNotes: "WITH_RO",
    link: true,
    buttons: [
      {
        external: true,
        link: smeSouqLink,
        label: "No, thanks"
      },
      {
        external: false,
        link: routes.comeBackLogin,
        label: "Yes"
      }
    ]
  }
];
export const screeningStatus = [
  {
    error: "Dedupe",
    screeningType: "Dedupe Check",
    //ro-assist-brd2-3
    link: true,
    buttons: [
      {
        external: false,
        link: routes.quickapplyLanding,
        label: "Back to home"
      }
    ]
  },
  {
    //ro-assist-brd1-3
    error: "Application Dedupe",
    screeningType: "Application Dedupe Check"
  },
  {
    error: "Virtual Currencies",
    screeningType: "Virtual Currency Check",
    link: true
  },
  {
    error: "iRBL Dedupe",
    screeningType: "iRBL Dedupe Check",
    link: true
  },
  {
    error: "BPM Dedupe",
    screeningType: "BPM Dedupe Check",
    link: true
  },
  {
    error: "Nationality Check",
    screeningType: "Nationality Check Of Sanction Country",
    link: true
  },
  {
    error: "Signatory BL/NL",
    screeningType: "Signatory BL/NL Checks",
    link: true
  },
  {
    error: "not Eligible",
    screeningType: "RAK-Starter Account Validation",
    link: true,
    //ro-assist-brd2-3
    buttons: [
      {
        external: false,
        link: routes.quickapplyLanding,
        label: "Back to home"
      }
    ]
  },
  {
    error: "Not Registered In UAE",
    screeningType: "Country Of Incorporation Check",
    link: true
    //link: true
  },
  {
    error: "Sanction Country",
    screeningType: "Sanction Country Of Incorporation Check",
    link: true
  },
  {
    error: "Big Company",
    screeningType: "ShareHolderCount Check",
    link: true
  },
  {
    error: "BlackList",
    screeningType: "Blacklist Check",
    link: true
  },
  {
    error: "Company as stakeholder",
    screeningType: "Company is a Stakeholder Check",
    link: true
  },
  {
    error: "Too many Stakeholders",
    screeningType: "Too many Stakeholders Check",
    link: true
  },
  {
    error: "Total No of Documents",
    screeningType: "Total No of Documents uploaded check",
    link: true
  },
  {
    error: "Company Firco",
    screeningType: "Company Firco Check",
    link: true
  },
  {
    error: "EFR check",
    screeningType: EFR_CHECK,
    link: true,
    buttons: [
      {
        external: true,
        link: process.env.REACT_APP_BAU_URL,
        label: "Back to home"
      }
    ]
  },
  {
    error: "FI",
    screeningType: "Company Industry and Sub-Industry Check",
    link: true
  },
  {
    error: 403,
    screeningType: 403,
    link: true
  },
  {
    error: "Local Dedupe",
    screeningType: "Local Dedupe Check",
    //ro-assist-brd2-3
    link: true,
    buttons: [
      {
        external: false,
        link: routes.comeBackLogin,
        label: "Go to Application"
      }
    ]
  },
  {
    error: "Ineligible country",
    screeningType: INELIGIBLE_COUNTRY_CHECK
  },
  {
    error: "Ineligible Country Check for Country of Birth",
    screeningType: INELIGIBLE_COUNTRY_CHECK_COUNTRY_OF_BIRTH
  },
  {
    error: "Tax Declaration Ineligible country",
    screeningType: INELIGIBLE_COUNTRY_CHECK_TAX_DECLARATION
  },
  {
    error: "Company Mailing Address",
    screeningType: "Company Mailing Address Check",
    link: true
  },
  {
    error: "Sanction Country Check for Top Customer & Supplier",
    screeningType: "Sanction Country Check for Top Customer & Supplier",
    link: true
  },
  {
    error: "Trade License Issusing Authority",
    screeningType: "Trade License Issusing Authority check",
    link: true
  },
  {
    error: "Sanction Country Check",
    screeningType: "Sanction Country Check",
    link: true
  },
  {
    error: "USA Country",
    screeningType: "USA Country check",
    link: true
  },
  {
    error: "MOI Entity",
    screeningType: "MOI Entity Check",
    link: true
  },
  {
    error: "Negative List",
    screeningType: "Negative List Check",
    link: true
  },
  {
    error: "Minor check",
    screeningType: "Minor check for Signatory",
    link: true
  },
  {
    error: "Passport Identity",
    screeningType: "Passport Identity Check",
    link: true
  },
  {
    error: "Signatory Dedupe",
    screeningType: "Signatory Dedupe Check",
    link: true
  },
  {
    error: "Sanction Country Check for Country Of Birth",
    screeningType: "Sanction Country Check for Country Of Birth",
    link: true
  },
  {
    error: "US Country Check for Country of Birth",
    screeningType: "US Country Check for Country of Birth",
    link: true
  },
  {
    error: "Signatory Firco",
    screeningType: "Signatory Firco Checks",
    link: true
  },
  {
    error: "AECB",
    screeningType: "AECB Check",
    link: true
  },
  {
    error: "IBAN Country",
    screeningType: "IBAN Country Check",
    link: true
  },
  {
    error: "AECB Fraud",
    screeningType: "AECB Fraud Check",
    link: true
  },
  {
    error: "Buyer 1 Firco",
    screeningType: "Buyer 1 Firco Check",
    link: true
  },
  {
    error: "Supplier 1 Firco",
    screeningType: "Supplier 1 Firco Check",
    link: true
  },
  {
    error: "Supplier 2 Firco",
    screeningType: "Supplier 2 Firco Check",
    link: true
  },
  {
    error: "Tax Declaration Sanction Country",
    screeningType: "Tax Declaration Sanction Country Check",
    link: true
  },
  {
    error: "TL Stakeholder Count Check",
    screeningType: TL_STAKEHOLDER_COUNT_CHECK,
    link: true
  },
  {
    error: "Company As shareholder",
    screeningType: "Company As shareholder",
    link: true
  },
  {
    error: "More than 4 Shareholders",
    screeningType: "More than 4 Shareholders",
    link: true
  },
  {
    error: "Company Category Decline",
    screeningType: "Company Category Decline",
    link: true
  },
  {
    error: "Shareholding Structure",
    screeningType: "Shareholding Structure",
    link: true
  },
  {
    error: "Branch of a UAE Company",
    screeningType: "Branch of a UAE Company",
    link: true
  },
  {
    error: "Branch of a Foreign Company",
    screeningType: "Branch of a Foreign Company",
    link: true
  },
  {
    error: "Private Joint Stock Company",
    screeningType: "Private Joint Stock Company",
    link: true
  },
  {
    error: "Public Listed Company (PLC)",
    screeningType: "Public Listed Company (PLC)",
    link: true
  },
  {
    error: "Public Joint Stock Companies (PJSC)",
    screeningType: "Public Joint Stock Companies (PJSC)",
    link: true
  }
];

//Ineligible status added for country check
export const SCREENING_FAIL_REASONS = ["Decline", "Match", "Match Found", "Ineligible"];

export const screeningStatusDefault = {
  icon: callbackRegular,
  link: true,
  error: "Default",
  text:
    "Thank you for your interest in RAKBANK$We apologise that we are unable to offer you a product as the details provided don't meet our requirements."
};

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_TIME_FORMAT = "yyyy-MM-dd hh:mm a";
export const TIME_FORMAT = "hh:mm a";
export const BYTES_IN_MEGABYTE = 1048576;

export const VIEW_IDS = {
  CompanyInfo: "/CompanyInfo",
  StakeholdersInfo: "/StakeholdersInfo",
  StakeholdersInfoPreview: "/StakeholdersInfoPreview",
  ConsentInfo: "/ConsentInfo",
  AdditionalInfo: "/AdditionalInfo",
  CompanyAdditionalInfo: "/CompanyAdditionalInfo",
  StakeholdersAdditionalInfo: "/StakeholdersAdditionalInfo",
  AccountInfo: "/AccountInfo",
  SubmitApplication: "/SubmitApplication",
  AdditionaData: "/AdditionalData",
  PartnershipDetailsInfo: "/PartnershipDetailsInfo",
  PartnerDetailsInfo: "/PartnerDetailsInfo",
  PartnershipSummaryInfo: "/PartnershipSummaryInfo",
  //V1 proespect view ids
  FinalQuestions: "/FinalQuestions",
  UploadDocuments: "/UploadDocuments",
  SelectServices: "/SelectServices",
  SearchProspect: "/SearchProspect",
  SearchedAppInfo: "/SearchedAppInfo",
  ApplicationSubmitted: "/ApplicationSubmitted",
  ReUploadDocuments: "/ReUploadDocuments",
  AccountServices: "/AccountServices",
  DulServiceSelectionInfo: "/DulServiceSelectionInfo",
  DulConsentInfo: "/DulConsentInfo"
};

export const VIEW_IDS_TILL_CONSENT = [
  "/CompanyInfo",
  "/StakeholdersInfo",
  "/StakeholdersInfoPreview",
  "/ConsentInfo"
];

export const EFR_VIEW_IDS = ["/StakeholdersInfo", "/StakeholdersInfoPreview", "/ConsentInfo"];

export const VIEW_IDS_AFTER_CONSENT = [
  "/CompanyAdditionalInfo",
  "/StakeholdersAdditionalInfo",
  "/AccountInfo",
  "/SubmitApplication"
];

export const AUTO_SAVE_DISABLED_VIEW_IDS = ["/StakeholdersInfo"];

export const ACTION_TYPES = {
  save: "save",
  submit: "submit"
};

export const RoleTypesForPersonas = {
  SP: [
    { code: "SP", value: "SP", label: "I am the owner of the company" }, //companyOwner
    {
      code: "SP_companyManager",
      value: "SP_companyManager",
      label: "I am a manager / employee in the company"
    },
    {
      code: "SP_powerOfAttorney",
      value: "SP_powerOfAttorney",
      label: "I hold power of attorney in the company"
    }
  ],
  MP: [
    {
      code: "MP", //companyShareholder
      value: "MP",
      label: "I am one of the shareholders in the company"
    },
    {
      code: "companyManager",
      value: "companyManager",
      label: "I am a manager / employee in the company"
    },
    {
      code: "powerOfAttorney",
      value: "powerOfAttorney",
      label: "I hold power of attorney in the company"
    }
  ]
  // ONBEHALF intentionally has no role types - clicking the accordion directly selects it
};

export const isShareholderCompanyOrEntityOptions = [
  {
    code: "No",
    key: "No",
    value: false,
    label: "All shareholders are individuals",
    icon: ICONS.users
  },
  {
    code: "Yes",
    key: "Yes",
    value: true,
    label: "Some shareholders are entities or companies",
    icon: ICONS.companyShareholder
  }
];

export const isAllUAEResidentsOptions = [
  {
    code: "Yes",
    key: "Yes",
    value: true,
    label: "All shareholders are UAE residents",
    icon: ICONS.uaeResident
  },
  {
    code: "No",
    key: "No",
    value: false,
    label: "Some shareholders are not UAE residents",
    icon: ICONS.nonUAEResident
  }
];

export const Personas = {
  SP: {
    key: "SP",
    title: "Single partner company",
    subTitle: [
      "A company owned and operated by one individual.",
      "Company that are registered as: Est, FZE, FZ LLC."
    ],
    url: routes.applicantInfo,
    urlType: "2.0",
    companyCategoryCode: "SOLE",
    order: 1
  },
  MP: {
    key: "MP",
    title: "Multi partner company",
    subTitle: [
      "A company with multiple shareholders.",
      "Company that are registered as: LLC or  FZCO"
    ],
    url: process.env.REACT_APP_BAU_URL || "/",
    urlType: "bau",
    companyCategoryCode: "PTP",
    order: 2
  },
  MPLL: {
    key: "MPLL",
    title: "Multi partner company",
    subTitle: [
      "A company with multiple shareholders. Company that are registered as: LLC or  FZCO"
    ],
    url: process.env.REACT_APP_BAU_URL || "/",
    urlType: "bau",
    companyCategoryCode: "LLC",
    order: 2
  },
  ONBEHALF: {
    key: "ONBEHALF",
    title: "I’m applying on behalf of someone else",
    subTitle: ["I have valid power of attorney, my company has another company as shareholder."],
    url: process.env.REACT_APP_BAU_URL || "/",
    urlType: "bau",
    companyCategoryCode: "ONBEHALF",
    order: 3
  },
  SPLL: {
    key: "SPLL",
    title: "I'm a Sole Proprietor with an LLC",
    subTitle: ["I do business as a limited liability company (LLC)/ Free Zone LLC"],
    url: routes.applicantInfo,
    urlType: "2.0",
    companyCategoryCode: "SLLC",
    order: 2
  }
};

export const SOLE_PROPRIETOR = "1";

export const FINAL_QUESTIONS_COMPANY_ID = "finalQuestionsCompany";
export const COMPANY_SIGNATORY_ID = "companySignatory_";

export const STEP_STATUS = {
  AVAILABLE: "AVAILABLE",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  COMPLETED: "COMPLETED"
};

// Company Check list
export const NEGATIVE_LIST_CHECK = {
  screeningType: "Negative List Check",
  screeningStatus: "Not completed",
  screeningLabel: "Negative List Check"
};
export const VIRTUAL_CURRENCY_CHECK = {
  screeningType: "Virtual Currency Check",
  screeningStatus: "Not completed",
  screeningLabel: "Virtual Currency Check"
};
export const COUNTRYOFINCORPORATION_CHECK = {
  screeningType: "Country Of Incorporation Check",
  screeningStatus: "Not completed",
  screeningLabel: "Offshore Company Check"
};
export const RAKSTARTER_ACCOUNT_CHECK = {
  screeningType: "RAK-Starter Account Validation",
  screeningStatus: "Not completed",
  screeningLabel: "RAK-Starter Account Validation"
};
export const DEDUPE_CHECK = {
  screeningType: "Dedupe Check",
  screeningStatus: "Not completed",
  screeningLabel: "Dedupe Check"
};
export const APPLICATION_DEDUPE_CHECK = {
  screeningType: "Application Dedupe Check",
  screeningStatus: "Not completed",
  screeningLabel: "Application Dedupe Check"
};
export const ISSHAREHOLDERACOMPANY_CHECK = {
  screeningType: "Company is a Stakeholder Check",
  screeningStatus: "Not completed",
  screeningLabel: "Company is a Stakeholder Check"
};
export const BLACKLIST_CHECK = {
  screeningType: "Blacklist Check",
  screeningStatus: "Not completed",
  screeningLabel: "Blacklist Check"
};
export const TOO_MANY_STAKEHOLDERS = {
  screeningType: "Too many Stakeholders Check",
  screeningStatus: "Not completed",
  screeningLabel: "Too many Stakeholders Check"
};
export const COMPANY_FIRCO_CHECK = {
  screeningType: "Company Firco Check",
  screeningStatus: "Not completed",
  screeningLabel: "Company Firco Check"
};

export const COMPANY_CHECK_NAMES = [
  DEDUPE_CHECK,
  APPLICATION_DEDUPE_CHECK,
  BLACKLIST_CHECK,
  NEGATIVE_LIST_CHECK,
  COUNTRYOFINCORPORATION_CHECK,
  VIRTUAL_CURRENCY_CHECK,
  RAKSTARTER_ACCOUNT_CHECK,
  ISSHAREHOLDERACOMPANY_CHECK,
  TOO_MANY_STAKEHOLDERS,
  COMPANY_FIRCO_CHECK
];

export const RAKSTARTER_ROUTE_PARAM = "rakstarter";
export const CURRENT_ACCOUNT_ROUTE_PARAM = "current-account";
export const ELITE_ROUTE_PARAM = "business-elite";
export const RAKSTARTER_ISLAMIC_ROUTE_PARAM = "rakstarter-islamic";
export const CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM = "current-account-islamic";
export const ELITE_ISLAMIC_ROUTE_PARAM = "business-elite-islamic";

export const AUTO_SAVE_INTERVAL = 40000;

export const UPLOADED = "Uploaded";

export const accountTypeURIs = {
  [RAKSTARTER_ROUTE_PARAM]: {
    accountType: accountNames.starter,
    isIslamicBanking: false
  },
  [CURRENT_ACCOUNT_ROUTE_PARAM]: {
    accountType: accountNames.currentAccount,
    isIslamicBanking: false
  },
  [ELITE_ROUTE_PARAM]: {
    accountType: accountNames.elite,
    isIslamicBanking: false
  },
  [RAKSTARTER_ISLAMIC_ROUTE_PARAM]: {
    accountType: accountNames.starter,
    isIslamicBanking: true
  },
  [CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM]: {
    accountType: accountNames.currentAccount,
    isIslamicBanking: true
  },
  [ELITE_ISLAMIC_ROUTE_PARAM]: {
    accountType: accountNames.elite,
    isIslamicBanking: true
  }
};

export const detailedAccountRoutesMap = {
  [accountNames.starter]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}`,
    [ISLAMIC]: `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}`
  },
  [accountNames.currentAccount]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}`,
    [ISLAMIC]: `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}`
  },
  [accountNames.elite]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}`,
    [ISLAMIC]: `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}`
  }
};

export const detailedAccountRoutes = [
  `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}`,
  `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}`,
  `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}`,
  `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}`
];

export const applicationOverviewRoutesMap = {
  [accountNames.starter]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}/application-overview`,
    [ISLAMIC]: `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}/application-overview`
  },
  [accountNames.currentAccount]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}/application-overview`,
    [ISLAMIC]: `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}/application-overview`
  },
  [accountNames.elite]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}/application-overview`,
    [ISLAMIC]: `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}/application-overview`
  }
};

export const applicationOverviewRoutes = [
  `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}/application-overview`,
  `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}/application-overview`
];

export const applicationPersona = [
  `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}/persona-selection`
];

export const personaSelectionRoutesMap = {
  [accountNames.starter]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}/persona-selection`,
    [ISLAMIC]: `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}/persona-selection`
  },
  [accountNames.currentAccount]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}/persona-selection`,
    [ISLAMIC]: `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}/persona-selection`
  },
  [accountNames.elite]: {
    [CONVENTIONAL]: `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}/persona-selection`,
    [ISLAMIC]: `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}/persona-selection`
  }
};

export const personaSelectionRoutes = [
  `${smeBaseName}/accounts/${RAKSTARTER_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${RAKSTARTER_ISLAMIC_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${CURRENT_ACCOUNT_ISLAMIC_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${ELITE_ROUTE_PARAM}/persona-selection`,
  `${smeBaseName}/accounts/${ELITE_ISLAMIC_ROUTE_PARAM}/persona-selection`
];

export const DEFAULT_REFERRAL_NAME = "Direct";
export const USER_IDLE_TIMEOUT = (process.env.REACT_APP_SESSION_TIMEOUT - 1) * 60 * 1000;
export const EXPIRY_INTERVAL = 60;
export const UPLOAD = "Upload ";

export const MOA_ACCEPTED_FILE_TYPES = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg"],
  "application/pdf": [".pdf"]
};

export const TL_ACCEPTED_FILE_TYPES = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg"],
  "application/pdf": [".pdf"]
};

export const SIGNATURE_ACCEPTED_FILE_TYPES = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg"]
};
export const SIGNATURE_FILE_SIZE = { minSize: "1024", maxSize: "3145728" };

export const DOC_TYPE_EID = "id";
export const DOC_TYPE_PASSPORT = "passport";
export const MOA_FILE_SIZE = { minSize: "9500", maxSize: "5242880" };
export const TL_COI_FILE_SIZE = { minSize: "9500", maxSize: "5242880" };

export const BBG_COMPANY_INFO_MODULEID = "SMA";

export const EID_PASSPORT_ACCEPTED_FILE_TYPES = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg"],
  "application/pdf": [".pdf"]
};
export const EID_PASSPORT_FILE_SIZE = { minSize: "9500", maxSize: "5242880" };

export const SESSION_TYPE = "STAKEHOLDER_KYC";

export const QR_CODE_REFRESH_BEFORE_SECONDS = 10000;

export const QR_CODE_SIZE = 300;

export const WTM_STATUS = {
  IN_PROGRESS: "IN PROGRESS",
  FINISHED: "COMPLETED",
  INACTIVE: "INACTIVE",
  CREATED: "CREATED"
};

export const BUSINESS_RELATIONSHIPS = {
  CUSTOMER_LIMIT: 3,
  SUPPLIER_LIMIT: 3
};
export const RAKvalue_PLUS = "RAKvalue PLUS";
export const RAKvalue_MAX = "RAKvalue MAX";

export const rakValuePackages = {
  [RAKvalue_PLUS]: "RAKvalue SME Plus",
  [RAKvalue_MAX]: "RAKvalue SME Max"
};

export const RAKvalue_SME_Plus = "RAKvalue SME Plus";
export const RAKvalue_SME_Max = "RAKvalue SME Max";

export const getFileUploadErrorMessage = {
  FILE_TOO_SMALL: "The file size is too small. Please upload a file that is at least 10KB",
  FILE_TOO_BIG: "The file size is too big. Please upload a file less than or equal to 5MB",
  INVALID_FILE_TYPE: "The file format is not supported. Please upload a valid file"
};

export const SUPPORTED_FILE_FORMAT_TEXT = "Supported formats: PDF, JPG, PNG | 5MB max. | 10KB min.";

export const SUPPORTED_FILE_FORMAT_TEXT_FOR_SIGNATURE =
  "Supported formats: JPG, PNG | 3MB max. | 1KB min.";

export const operatorLoginScheme = "DBOP";

export const invalidDocument = {
  message: "Invalid document",
  title: "Something went wrong"
};

export const tokenExpired = {
  message: "Please try again",
  title: "Something went wrong"
};

export const CHAT_INFO = {
  HEADER_ENG: "Important Info:",
  HEADER_AR: ":معلومات مهمة",
  DESC_ENG:
    "\nWhile our complete revamped bilingual webchat is work in progress, to view the current content in Arabic, simply select Arabic Language from the Accessibility menu.",
  DESC_AR:
    "\nنحن بصدد تجديد دردشة الويب ثنائية اللغة بالكامل، ولذلك، لعرض المحتوى الحالي باللغة العربية، ما عليك سوى تحديد اللغة العربية من قائمة إمكانية الوصول المتوفرة على موقعنا",
  ICON_DESC_ENG: "To chat with us in Arabic,",
  ICON_DESC_AR: "للتكلم معنا بالعربية",
  PLEASE_CALL_ENG: "please call",
  PLEASE_CALL_AR: "يرجى الاتصال على",
  PHONE_NUM: "04 213 0000"
};

export const APPLICATION_APPROVAL_MESSAGE =
  "This is so you can collect your chequebook and debit card in person, if requested.";

export const APPLICATION_TITLE_MESSAGE = "Reminder: You will need to be in the UAE";

export const APPLICATION_APPROVAL_INFO =
  "When your application is approved, we'll send you a confirmation letter with your chequebook and debit card (if applied).";

export const USER_TO_SHOW_PROSECT_FIELD_IN_SEARCH_FORM = [operatorLoginScheme];

export const SP_WARNING_MESSAGE =
  "We’ll use the contact details given by you for all future banking communication. Please enter the correct business contact details.";

export const MULTI_PARTNER_PERSONA = ["MP", "MPLL"];

export const SOLE_PERSONA = ["SP", "SPLL"];

export const EFR_COMPLETED_MESSAGES =
  "A Relationship Manager will now take care of the next steps to complete your application";

export const AUTH_CLIENT_ID = "bbg-web-onboarding";
export const AUTH_CLIENT_SECRET = process.env.REACT_APP_AUTH_CLIENT_SECRET;
export const AUTH_RESOURCE_TYPE = "bbg_stp_accounts_onboarding";
export const AGENT_AUTH_RESOURCE_TYPE = "bbg_agent_stp_accounts_onboarding";
export const AUTH_API_KEY = process.env.REACT_APP_AUTH_API_KEY;

export const DEFAULT_SIGNATORY_ID = "SID1";

export const CV_DOCUMENT_PATHS = {
  SIGNATORY: "prospect.prospectDocuments.stakeholderAdditionalInfo.backgroundDetails.cv",
  NON_SIGNATORY:
    "prospect.prospectDocuments.stakeholderAdditionalInfo.shareholder.backgroundDetails.cv"
};

export const PROOF_OF_INCOME_DOCUMENT_PATHS = {
  SIGNATORY:
    "prospect.prospectDocuments.stakeholderAdditionalInfo.sourceOfIncomeDetails.proofOfIncome",
  NON_SIGNATORY:
    "prospect.prospectDocuments.stakeholderAdditionalInfo.shareholder.sourceOfIncomeDetails.proofOfIncome"
};

export const DOCUMENT_TYPES = {
  PASSPORT: "passport",
  PASSPORT_FRONT: "passport front",
  PASSPORT_BACK: "passport back",
  TRADE_LICENSE: "Trade License",
  EMIRATES_ID: "Emirates ID",
  EMIRATES_ID_FRONT: "Emirates ID Front",
  EMIRATES_ID_BACK: "Emirates ID Back",
  VAT: "VAT",
  PROOF_OF_ADDRESS: "Proof of Address",
  CORPORATE_TAX: "Corporate Tax",
  CHEQUE: "Cheque"
};

export const OCR_DATA_FETCH_TIMEOUT = 15000;

export const OCR_FETCHED_PAGE_COUNT = 3;

/**
 * Trade License specific OCR field mapping
 */
export const TRADE_LICENSE_FIELD_MAPPING = {
  company_name: "ocrCompanyName",
  license_no: "licenseOrCOINumber",
  expiry_date: "licenseOrCOIExpiryDate",
  issue_date: "issueDate",
  issuing_authority_footer: "licenseIssuingAuthorityFooter",
  issuing_authority_header: "licenseIssuingAuthorityHeader",
  estd_date: "establishmentDate",
  additional_tlia: "additionalTlIA",
  trade_name: "ocrTradeName"
};

export const EMIRATES_ID_FIELD_MAPPING = {
  id_number: "eidNumber",
  expiry_date: "kycDetails.emirateIdDetails.eidExpiryDt"
};

export const PASSPORT_FIELD_MAPPING = {
  given_names: "firstName",
  middleName: "middleName",
  surname: "lastName",
  place_of_birth: "placeOfBirth",
  passport_no: "kycDetails.passportDetails[0].passportNumber",
  date_of_issue: "kycDetails.passportDetails[0].passportIssueDate",
  date_of_expiry: "kycDetails.passportDetails[0].passportExpiryDate",
  name_of_mother: "mothersMaidenName",
  sex: "partnerGender",
  country_code: "ISO3CountryCode",
  date_of_birth: "kycDetails.dateOfBirth"
};

export const DOCUMENT_UPLOAD_MESSAGE = "Scanning your documents....this might take few moments";

export const OCR_DOCUPLOAD_MESSAGE = "Uploading your documents....this might take few moments";

export const CARD_TYPE_BUSINESS_DEBIT = "Business debit card";
export const CARD_TYPE_DIGITAL_ACCESS = "Digital access card";
export const CONVENTIONAL_URL =
  "https://www.rakbank.ae/globalassets/rakbank/all-pdfs/001---service-and-price-guides/bilingual/010-j00183-sp-vat-businessaccountservices-rakstarter3.pdf";
export const ISLAMIC_URL =
  "https://www.rakbank.ae/globalassets/rakbank/all-pdfs/002---islamic---service-and-price-guides/bilingual/026-j00807-sp-vat-businessaccountservices-islamic.pdf";

export const WOMEN_ENTERPRENEURSHIP_TERMS_AND_CONDITIONS_URL =
  "https://www.rakbank.ae/globalassets/rakbank/all-pdfs/001---terms-and-conditions/we_proposition_tnc.pdf";

export const TL_DATA_FETCH_CONSENT_TEXT =
  // eslint-disable-next-line quotes
  'I/We hereby authorize The National Bank of Ras Al Khaimah (PSC) (“RAKBANK”) to securely connect with Ras Al Khaimah Economic Zone ("RAKEZ") and consent to retrieve, verify, store, use and process my/our company’s trade license and related company information directly from RAKEZ for the purposes of onboarding my/our company with RAKBANK.';
export const TL_DATA_FETCH_ERROR_MESSAGE =
  "We are unable to fetch your details at the moment. Please fill in the required details manually to proceed.";

export const CompanyDocumentKeys = {
  Moa: "prospect.prospectDocuments.companyDocument.moa",
  TradeLicenseOrCOI: "prospect.prospectDocuments.companyDocument.tradeLicenseOrCOI",
  Hawala: "prospect.prospectDocuments.additionalCompanyDocument.hawalaAuthorizedLicense",
  LicenseDoc_TL: "Authority_Trade_License",
  LicenseDoc_Moa: "Authority_Memorandum_of_Association",
  LicenseDoc_AddendumToMoa: "Authority_Addendum_to_Memorandum_of_Association"
};
